"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */
var _default = {
  device: {
    preDiscoveryServices: {
      atlasServiceUrl: process.env.ATLAS_SERVICE_URL || 'https://atlas-a.wbx2.com/admin/api/v1',
      atlas: process.env.ATLAS_SERVICE_URL || 'https://atlas-a.wbx2.com/admin/api/v1'
    }
  },
  user: {
    batcherWait: 100,
    batcherMaxCalls: 100,
    batcherMaxWait: 1500,
    verifyDefaults: {
      reqId: 'WEBCLIENT'
    }
  }
};
exports.default = _default;
//# sourceMappingURL=config.js.map
